/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconSoAuthorization = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-so-authorization',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M6.746 21.763a.802.802 0 0 0 0-1.146l-1.752-1.72 1.752-1.718 1.752 1.719a.837.837 0 0 0 .798.21.818.818 0 0 0 .584-.573.8.8 0 0 0-.214-.783l-1.752-1.719 5.308-5.208a5.036 5.036 0 0 0 4.68.564 4.888 4.888 0 0 0 3.042-3.533 4.802 4.802 0 0 0-1.347-4.432 5.018 5.018 0 0 0-4.517-1.321 4.93 4.93 0 0 0-3.6 2.985 4.785 4.785 0 0 0 .574 4.59l-8.812 8.647a.803.803 0 0 0 0 1.146l2.336 2.292a.834.834 0 0 0 1.168 0Zm7.008-17.19c.62-.607 1.46-.949 2.336-.949.876 0 1.716.342 2.336.95a3.21 3.21 0 0 1 .967 2.291 3.21 3.21 0 0 1-.967 2.292c-.62.608-1.46.95-2.336.95a3.336 3.336 0 0 1-2.336-.95 3.21 3.21 0 0 1-.968-2.292c0-.86.348-1.684.968-2.292Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconSoAuthorization.displayName = 'IconSoAuthorization';
export default IconSoAuthorization;
